<template>
  <div class="overview">
    <h2 class="overview-title">Auftragsübersicht</h2>
    <div class="overview-wrapper">
      <div class="content-wrapper">
        <div style="width: 100%">
          <div>
            <p class="overview-section-title">
              Zusammenfassung Ihrer Antworten
            </p>
            <ul class="overview-list-items">
              <li v-for="answer in $store.state.overviewData.content" :key="answer.questionId">
                <span>
                  <span class="overview-questions">{{ answer.question }}</span>
                  <strong> - {{ answer.answers }}</strong>
                </span>
              </li>
            </ul>

            <hr class="my-4" />

            <p class="overview-section-title">Service-Leistungen</p>
            <ul class="overview-list-items services-overview">
              <li v-for="service in $store.state.selectedRepairServices" :key="service.id">
                <span>
                  {{ service.title }}
                  <template v-if="warrantyImage.length !== 0">
                    <span v-if="!service.priceOnDemand">
                      <span v-if="service.priceRange">
                        (ab {{ service.price | currency }}) <sup> 1 </sup>
                      </span>
                      <span v-else-if="!service.priceRange">
                        ({{ service.price | currency }}) <sup> 1 </sup>
                      </span>
                    </span>
                    <span v-else> - Auf Anfrage <sup> 1 </sup> </span>
                  </template>
                  <template v-else-if="watchProtectionImage.length !== 0">
                    <span v-if="!service.priceOnDemand">
                      <span v-if="service.priceRange">
                        (ab {{ service.price | currency }}) <sup> 1 </sup>
                      </span>
                      <span v-else-if="!service.priceRange">
                        ({{ service.price | currency }}) <sup> 1 </sup>
                      </span>
                    </span>
                    <span v-else> - Auf Anfrage <sup> 1 </sup> </span>
                  </template>
                  <template v-else>
                    <span v-if="hasPrice && !requireOffer">
                      <span v-if="service.priceRange">
                        (ab {{ service.price | currency }}) <sup> 1 </sup>
                      </span>
                      <span v-else>
                        ({{ service.price | currency }}) <sup> 1 </sup>
                      </span>
                    </span>
                    <span v-else-if="hasPrice && requireOffer">
                      <span v-if="!service.priceOnDemand">
                        <span v-if="service.priceRange">
                          (ab {{ service.price | currency }})
                          <sup> 1 </sup></span>
                        <span v-else>({{ service.price | currency }}) <sup> 1 </sup></span>
                      </span>
                      <span v-else> - Auf Anfrage <sup> 2 </sup> </span>
                    </span>
                    <span v-else-if="!hasPrice && requireOffer">
                      <span> - Auf Anfrage <sup> 1 </sup> </span>
                    </span>
                  </template>
                </span>
              </li>
            </ul>
            <div v-if="warrantyImage.length !== 0">
              <div style="float: left; margin-right: 1em">
                <small>1</small>
              </div>
              <div style="overflow: hidden">
                <small>                  
                  Wir nehmen Ihren Reparaturwunsch im Rahmen der Anfrage auf Gewährleistung entgegen und prüfen diesen.
                  Sofern es sich um einen Gewährleistungsfall handelt, übernehmen wir selbstverständlich die Kosten.
                  Ansonsten erstellen wir Ihnen im Anschluss einen unverbindlichen Kostenvoranschlag.
                </small>
              </div>
            </div>
            <div v-else-if="watchProtectionImage.length !== 0">
              <div style="float: left; margin-right: 1em">
                <small>1</small>
              </div>
              <div style="overflow: hidden">
                <small>
                  Wir nehmen Ihren Uhrenschutzfall entgegen und prüfen diesen.
                  Bitte beachten Sie, dass Ihnen als Versicherungsnehmer:in bei
                  dem hier aufgeführten Preis - bei allen Schäden - ein
                  Selbstbehalt von 20% des Schadenersatzes verrechnet wird. Wir
                  weisen darauf hin, dass die Obergrenze der Gesamtentschädigung
                  der Versicherungswert der Uhr ist, wobei bereits geleistete
                  Entschädigungen für Vorschäden (z.B. Mehrfachreparaturen)
                  mitgerechnet werden. Sollte aus der Prüfung unserer
                  Service-Werkstätten hervorgehen, dass der Uhrenschutz in Ihrem
                  Fall nicht gewährleistet werden kann, erstellen wir Ihnen im
                  Anschluss einen unverbindlichen Kostenvoranschlag.
                </small>
              </div>
            </div>
            <div v-else>
              <span v-if="hasPrice && !requireOffer">
                <div style="float: left; margin-right: 1em">
                  <small>1</small>
                </div>
                <div style="overflow: hidden">
                  <small>
                    Das Preisangebot ist unverbindlich und versteht sich inkl.
                    Mwst. Sollte der Verkaufspreis nach Auftragseingang und
                    anschließender Einschätzung durch unsere Service-Werkstätten
                    um mehr als 10% vom online ermittelten Wert abweichen,
                    erstellen wir Ihnen einen unverbindlichen Kostenvoranschlag.
                  </small>
                </div>
              </span>
              <span v-else-if="hasPrice && requireOffer">
                <div style="float: left; margin-right: 1em">
                  <small>1</small>
                </div>
                <div style="overflow: hidden">
                  <small>
                    Das Preisangebot ist unverbindlich und versteht sich inkl.
                    Mwst. Sollte der Verkaufspreis nach Auftragseingang und
                    anschließender Einschätzung durch unsere Service-Werkstätten
                    um mehr als 10% vom online ermittelten Wert abweichen,
                    erstellen wir Ihnen einen unverbindlichen Kostenvoranschlag.
                  </small>
                </div>
                <div style="float: left; margin-right: 1em">
                  <small>2</small>
                </div>
                <div style="overflow: hidden">
                  <small>
                    Nach Eingang Ihres Auftrags in den Service-Werkstätten
                    erhalten Sie innerhalb von 5 Werktagen einen individuellen
                    Kostenvoranschlag von uns per E-Mail.
                  </small>
                </div>
              </span>
              <span v-else-if="!hasPrice && requireOffer">
                <div style="float: left; margin-right: 1em">
                  <small>1</small>
                </div>
                <div style="overflow: hidden">
                  <small>
                    Nach Eingang Ihres Auftrags in den Service-Werkstätten
                    erhalten Sie innerhalb von 5 Werktagen einen individuellen
                    Kostenvoranschlag von uns per E-Mail.
                  </small>
                </div>
              </span>
            </div>

            <hr class="my-4" />

            <div v-if="formData.images.length" class="d-flex align-itmes-center">
              <p class="overview-section-title">Fotouploads</p>
              <router-link class="ml-auto font-weight-bold" :to="{ name: 'ConditionCheck' }">
                <img src="@/assets/images/overview/edit.svg" alt="Bearbeiten" />
              </router-link>
            </div>
            <div class="form-preview-images">
              <div v-for="(image, index) in formData.images" :key="index" class="mr-3 mb-3">
                <img :src="image.preview" class="img-fluid mh-100" />
              </div>
            </div>

            <div v-if="conditionDescription && conditionDescription != null">
              <strong>Schadensbeschreibung:</strong> {{ conditionDescription }}
            </div>

            <hr v-if="
              (warrantyImage != null && warrantyImage.length != 0) ||
              (watchProtectionImage != null &&
                watchProtectionImage.length != 0)
            " />

            <div v-if="
              (warrantyImage != null && warrantyImage.length != 0) ||
              (watchProtectionImage != null &&
                watchProtectionImage.length != 0)
            " class="d-flex align-itmes-center">
              <p class="overview-section-title">Belege</p>
              <router-link class="ml-auto font-weight-bold" :to="{ name: 'Cart' }">
                <img src="@/assets/images/overview/edit.svg" alt="Bearbeiten" />
              </router-link>
            </div>
            <div class="form-preview-images" v-if="
              warrantyImage &&
              warrantyImage != null &&
              warrantyImage.length != 0
            ">
              <div v-for="(image, index) in warrantyImage" :key="index" class="mr-3 mb-3">
                <img :src="image.preview" class="img-fluid mh-100" />
              </div>
            </div>
            <div class="form-preview-images" v-if="
              watchProtectionImage &&
              watchProtectionImage != null &&
              watchProtectionImage.length != 0
            ">
              <div v-for="(image, index) in watchProtectionImage" :key="index" class="mr-3 mb-3">
                <img :src="image.preview" class="img-fluid mh-100" />
              </div>
            </div>

            <div v-if="
              watchProtectionImage &&
              watchProtectionImage != null &&
              watchProtectionImage.length != 0
            ">
              <p><strong>Antworten zum Uhrenschutz</strong></p>
              <strong>Datum:</strong> {{ orderProtectionInfo.damageDate }}
              <br />
              <strong>Beschreibung:</strong>
              {{ orderProtectionInfo.damageDescription }}
            </div>

            <hr class="my-4" />

            <div class="d-flex align-items-center">
              <p class="overview-section-title">Ihre Daten</p>
              <router-link class="ml-auto font-weight-bold" :to="{ name: 'PersonalData' }">
                <img src="@/assets/images/overview/edit.svg" alt="Bearbeiten" />
              </router-link>
            </div>

            <div class="overview-personal">
              <div class="overview-address">
                <p><strong>Adresse</strong></p>
                {{ formData.salutation }}
                <br />
                {{ formData.firstname }} {{ formData.lastname }}
                <br />
                {{ formData.street }} {{ formData.number }}
                <br />
                {{ formData.zip }} {{ formData.city }}
                <br />
                {{ formData.countryCode }}
              </div>
              <div class="overview-personal-tablet">
                <div class="overview-mail">
                  <p><strong>E-Mail Adresse</strong></p>
                  {{ formData.email }}
                </div>
                <div class="overview-phone">
                  <p><strong>Telefonnummer</strong></p>
                  {{ formData.phone }}
                </div>
                <div class="overview-contact" v-if="formData.contact">
                  <p><strong>Bevorzugte Kontaktzeiten (Mo-Fr)</strong></p>
                  {{ formData.contact.toString() }}
                </div>
              </div>
              <div class="overview-personal-desktop">
                <div>
                  <p><strong>E-Mail Adresse</strong></p>
                  {{ formData.email }}
                </div>
              </div>
              <div class="overview-personal-desktop">
                <div class="overview-phone">
                  <p><strong>Telefonnummer</strong></p>
                  {{ formData.phone }}
                </div>
                <div class="overview-contact" v-if="formData.contact">
                  <p><strong>Bevorzugte Kontaktzeiten (Mo-Fr)</strong></p>
                  {{ formData.contact.toString() }}
                </div>
              </div>
            </div>

            <hr class="my-4" />

            <div class="d-flex align-itmes-center my-3">
              <p class="overview-section-title">Versand & Zahlung</p>
            </div>
            <div class="overview-payment">
              <div>
                <strong>Versand</strong><br />
                DHL Paket
              </div>
              <div>
                <strong>Zahlungsart</strong><br />
                Rechnung
              </div>
            </div>

            <hr class="my-4" />

            <p class="overview-section-title">AGB und Datenschutz</p>

            <div class="custom-control custom-checkbox">
              <input id="privacy" v-model="formData.privacy" type="checkbox" class="custom-control-input"
                :class="hasError('privacy') ? 'is-invalid' : ''" />
              <label class="custom-control-label" for="privacy">
                <span style="margin-right: 4px">Ich stimme den </span>
                <a class="underlined-link" href="https://www.christ.de/content/legal/agb" target="_blank">AGB</a>
                <span style="margin-left: 4px"> zu.</span>
              </label>
              <div v-if="hasError('privacy')" class="invalid-feedback">
                <div v-if="!$v.formData.privacy.required" class="error">
                  Bitte die Datenschutzbestimmungen akzeptieren.
                </div>
              </div>
            </div>

            <div class="privacy">
              Datenschutz: Hier gelangen Sie zu unserer
              <a class="underlined-link" href="https://www.christ.de/content/legal/datenschutz"
                target="_blank">Datenschutzerklärung</a>
              und zu den
              <a class="underlined-link" href="https://www.christ.de/information-datenschutz" target="_blank">Hinweisen
                zur Datennutzung.</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Overview",
  validations: {
    formData: {
      privacy: { required, sameAs: sameAs(() => true) },
    },
  },
  data() {
    return {
      requireOffer: false,
      hasPrice: false,
    };
  },
  computed: {
    warrantyImage: {
      get() {
        return this.$store.state.warrantyImage;
      },
      set(value) {
        this.$store.commit("setWarrantyImage", value);
      },
    },
    watchProtectionImage: {
      get() {
        return this.$store.state.watchProtectionImage;
      },
      set(value) {
        this.$store.commit("setWatchProtectionImage", value);
      },
    },
    orderProtectionInfo: {
      get() {
        return this.$store.state.orderProtectionInfo;
      },
      set(value) {
        this.$store.commit("setorderProtectionInfo", value);
      },
    },
    overviewData: {
      get() {
        return this.$store.state.overviewData;
      },
      set(value) {
        this.$store.commit("setOverview", value);
      },
    },
    conditionDescription: {
      get() {
        return this.$store.state.conditionDescription;
      },
      set(value) {
        this.$store.commit("setConditionDescription", value);
      },
    },
    formData: {
      get() {
        return this.$store.state.checkoutFormData;
      },
      set(value) {
        this.$store.commit("updateCheckoutFormData", value);
      },
    },
  },
  mounted() {
    this.$store.commit("setValidation", this.$v);
    this.calculate();
    this.checkPrices();
  },
  methods: {
    hasError(fieldName) {
      return (
        fieldName in this.$v.formData && this.$v.formData[fieldName].$error
      );
    },
    checkPrices() {
      var services = this.$store.state.selectedRepairServices;
      services.forEach((element) => {
        if (element.priceOnDemand) {
          this.requireOffer = true;
        } else {
          this.hasPrice = true;
        }
      });
    },
    calculate() {
      if (this.$store.state.isClock) {
        if (!this.$store.state.watchProtectionImagePriceIsCalculated) {
          if (this.watchProtectionImage.length != 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null && service.price !== 0) {
                service.backup = service.price;
                service.durationBackup = service.duration;
                service.price *= 0.2;
                service.duration = "ca. 6 bis 8 Wochen";
              }
            });
          }
          else if (this.warrantyImage.length != 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null && service.price !== 0) {
                service.backup = service.price;
                service.price = 0;
                service.durationBackup = service.duration;
                service.duration = "ca. 6 bis 8 Wochen";
              }
            });
          }
          else {
            this.$store.state.selectedRepairServices.forEach((service) => {
              service.backup = service.price;
              service.durationBackup = service.duration;
            })
          }
          this.$store.commit("setWatchProtectionPriceIsCalculated", true);
        } else if (this.$store.state.watchProtectionImagePriceIsCalculated) {
          if (
            this.watchProtectionImage.length == 0 &&
            this.warrantyImage.length == 0
          ) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null) {
                service.price = service.backup;
                service.duration = service.durationBackup;
              }
            });
            this.$store.commit("setWatchProtectionPriceIsCalculated", false);
          } else if (this.watchProtectionImage.length !== 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null) {
                service.price = service.backup * 0.2;
                service.duration = service.durationBackup;
              }
            });
            this.$store.commit("setWatchProtectionPriceIsCalculated", true);
          } else if (this.warrantyImage.length !== 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null && service.price !== 0) {
                service.backup = service.price;
                service.price = 0;
                service.durationBackup = service.duration;
                service.duration = "ca. 6 bis 8 Wochen";
              }
            });
            this.$store.commit("setWatchProtectionPriceIsCalculated", true);
          }
        }
      } else {
        if (!this.$store.state.warrantyPriceIsCalculated) {
          if (this.warrantyImage.length !== 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null && service.price !== 0) {
                service.backup = service.price;
                service.price = 0;
                service.durationBackup = service.duration;
                service.duration = "ca. 6 bis 8 Wochen";
              }
            });
          }
          else {
            this.$store.state.selectedRepairServices.forEach((service) => {
              service.backup = service.price;
              service.durationBackup = service.duration;
            })
          }
          this.$store.commit("setWarrantyPriceIsCalculated", true);
        } else {
          if (this.warrantyImage.length == 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {
              if (service.price !== null) {
                service.price = service.backup;
                service.duration = service.durationBackup;
              }
            });
            this.$store.commit("setWarrantyPriceIsCalculated", false);
          } else if (this.warrantyImage.length !== 0) {
            this.$store.state.selectedRepairServices.forEach((service) => {

              if (service.price !== null && service.price !== 0) {
                service.backup = service.price;
                service.price = 0;
                service.durationBackup = service.duration;
                service.duration = "ca. 6 bis 8 Wochen";
              }
            });
            this.$store.commit("setWarrantyPriceIsCalculated", true);
          }
        }
      }
    },
  },
};
</script>
